import PropTypes from 'prop-types';
import React from 'react';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import Rows from 'app/components/shared/browse/Rows';
import { rowShape } from 'app/shapes/browse/rows';

import './BrowseHomePage.scss';

const BrowseHomePage = ({
  pageTitle,
  rows,
  trackBibClick,
  trackBibsRowTitleClick,
  trackLinksRowLinkClick,
  trackListCreatorClick,
  trackListImageClick,
  trackListImpression,
  trackListTitleClick,
  trackNavLinkClick
}) => {
  return (
    <div className="cp-browse-home-page">
      <ScreenReaderMessage>
        <h1>{pageTitle}</h1>
      </ScreenReaderMessage>
      <Rows
        rows={rows}
        trackBibClick={trackBibClick}
        trackBibsRowTitleClick={trackBibsRowTitleClick}
        trackLinksRowLinkClick={trackLinksRowLinkClick}
        trackListCreatorClick={trackListCreatorClick}
        trackListImageClick={trackListImageClick}
        trackListImpression={trackListImpression}
        trackListTitleClick={trackListTitleClick}
        trackNavLinkClick={trackNavLinkClick}
      />
    </div>
  );
};

BrowseHomePage.defaultProps = {
  trackBibClick: () => null,
  trackBibsRowTitleClick: () => null,
  trackLinksRowLinkClick: () => null,
  trackListCreatorClick: () => null,
  trackListImageClick: () => null,
  trackListImpression: () => null,
  trackListTitleClick: () => null,
  trackNavLinkClick: () => null
};

BrowseHomePage.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(rowShape).isRequired,
  trackBibClick: PropTypes.func,
  trackBibsRowTitleClick: PropTypes.func,
  trackLinksRowLinkClick: PropTypes.func,
  trackListCreatorClick: PropTypes.func,
  trackListImageClick: PropTypes.func,
  trackListImpression: PropTypes.func,
  trackListTitleClick: PropTypes.func,
  trackNavLinkClick: PropTypes.func
};

export default BrowseHomePage;
